export default __webpack_public_path__ + "static/media/Edit.e8fa7a4f.svg";